import { SEO_CONTENT } from "constants/Seo";
import React, { ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

// Define the types for the props
interface HelmetWrapperProps {
  content: { TITLE: string; DESCRIPTION?: string };
  children?: ReactNode; // Optional children prop, which can accept any valid JSX elements
}

export const HelmetWrapper: React.FC<HelmetWrapperProps> = ({
  content,
  children,
}) => {
  const location = useLocation();

  return (
    <>
      <Helmet key={location?.pathname}>
        <title>{content?.TITLE || SEO_CONTENT.HOME.TITLE}</title>
        <meta name={content?.TITLE || SEO_CONTENT.HOME.TITLE} />
        <meta
          name="description"
          content={content?.DESCRIPTION || SEO_CONTENT.HOME.DESCRIPTION}
        />
        <link
          rel="canonical"
          href={`${import.meta.env.VITE_PUBLIC_URL}${location?.pathname}`}
        />
      </Helmet>
      {children}
    </>
  );
};
